<template>
  <form class="validate-form" @submit.prevent="handleSave">
    <div>
      <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
        <MessageSquareIcon />
        <h2 class="text-lg font-medium mr-auto">{{ $t('news.add') }}</h2>
        <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
          <button type="submit" class="btn btn-primary shadow-md flex items-center">
            <SaveIcon class="w-4 h-4 mr-2" /> {{ $t('common.save') }}
          </button>
          <router-link
            :to="{ name: 'superadmin-tools-news' }"
            tag="a"
            class="btn shadow-md flex items-center"
          >
            <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
          </router-link>
        </div>
      </div>
      <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
        <div class="col-span-12">
          <div class="intro-y box p-5">
            <div class="post intro-y overflow-hidden box mt-5">
              <div
                class="post__tabs nav nav-tabs flex-col sm:flex-row bg-gray-300 dark:bg-dark-2 text-gray-600"
                role="tablist"
              >
                <a
                  id="sk-tab"
                  data-toggle="tab"
                  data-target="#sk"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center active"
                  role="tab"
                  aria-controls="sk"
                  aria-selected="true"
                >
                  <country-flag country="sk" size="small" />
                  {{ $t('common.language.sk_SK') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#en"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="en"
                  aria-selected="false"
                >
                  <country-flag country="gb" size="small" />
                  {{ $t('common.language.en_UK') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#cs"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="cs"
                  aria-selected="false"
                >
                  <country-flag country="cz" size="small" />
                  {{ $t('common.language.cs_CZ') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#de"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="de"
                  aria-selected="false"
                >
                  <country-flag country="de" size="small" />
                  {{ $t('common.language.de_DE') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#pl"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="pl"
                  aria-selected="false"
                >
                  <country-flag country="pl" size="small" />
                  {{ $t('common.language.pl_PL') }}
                </a>
              </div>
              <div class="tab-content">
                <div
                  class="tab-pane active"
                  id="sk"
                  role="tabpanel"
                  aria-labelledby="sk-tab"
                >
                  <div class="mt-3">
                    <label
                      for="headerSk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="headerSk"
                      v-model.trim="validate.headerSk.$model"
                      type="text"
                      header="headerSk"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.headerSk.$error }"
                      placeholder=""
                    />
                    <label
                      for="perexSk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="perexSk"
                      v-model.trim="validate.perexSk.$model"
                      type="text"
                      perex="perexSk"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.perexSk.$error }"
                      placeholder=""
                    />
                    <label
                      for="bodySk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('news.body') }}
                    </label>
                    <textarea
                      id="bodySk"
                      name="bodySk"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.bodySk.$error }"
                      v-model.trim="validate.bodySk.$model"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="tab-pane" id="en" role="tabpanel" aria-labelledby="en-tab">
                  <div class="mt-3">
                    <label
                      for="headerEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="headerEn"
                      v-model.trim="validate.headerEn.$model"
                      type="text"
                      header="headerEn"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.headerEn.$error }"
                      placeholder=""
                    />
                    <label
                      for="perexEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="perexEn"
                      v-model.trim="validate.perexEn.$model"
                      type="text"
                      perex="perexEn"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.perexEn.$error }"
                      placeholder=""
                    />
                    <label
                      for="bodyEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('news.body') }}
                    </label>
                    <textarea
                      id="bodyEn"
                      name="bodyEn"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.bodyEn.$error }"
                      v-model.trim="validate.bodyEn.$model"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="tab-pane" id="cs" role="tabpanel" aria-labelledby="cs-tab">
                  <div class="mt-3">
                    <label
                      for="headerCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="headerCs"
                      v-model.trim="validate.headerCs.$model"
                      type="text"
                      header="headerCs"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.headerCs.$error }"
                      placeholder=""
                    />
                    <label
                      for="perexCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="perexCs"
                      v-model.trim="validate.perexCs.$model"
                      type="text"
                      perex="perexCs"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.perexCs.$error }"
                      placeholder=""
                    />
                    <label
                      for="bodyCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('news.body') }}
                    </label>
                    <textarea
                      id="bodyCs"
                      name="bodyCs"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.bodyCs.$error }"
                      v-model.trim="validate.bodyCs.$model"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="tab-pane" id="de" role="tabpanel" aria-labelledby="de-tab">
                  <div class="mt-3">
                    <label
                      for="headerDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="headerDe"
                      v-model.trim="validate.headerDe.$model"
                      type="text"
                      header="headerDe"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.headerDe.$error }"
                      placeholder=""
                    />
                    <label
                      for="perexDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="perexDe"
                      v-model.trim="validate.perexDe.$model"
                      type="text"
                      perex="perexDe"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.perexDe.$error }"
                      placeholder=""
                    />
                    <label
                      for="bodyDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('news.body') }}
                    </label>
                    <textarea
                      id="bodyDe"
                      name="bodyDe"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.bodyDe.$error }"
                      v-model.trim="validate.bodyDe.$model"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="tab-pane" id="pl" role="tabpanel" aria-labelledby="pl-tab">
                  <div class="mt-3">
                    <label
                      for="headerPl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="headerPl"
                      v-model.trim="validate.headerPl.$model"
                      type="text"
                      header="headerPl"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.headerPl.$error }"
                      placeholder=""
                    />
                    <label
                      for="perexPl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                      <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="perexPl"
                      v-model.trim="validate.perexPl.$model"
                      type="text"
                      perex="perexPl"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.perexPl.$error }"
                      placeholder=""
                    />
                    <label
                      for="bodyPl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('news.body') }}
                    </label>
                    <textarea
                      id="bodyPl"
                      name="bodyPl"
                      class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                      :class="{ 'border-theme-6': validate.bodyPl.$error }"
                      v-model.trim="validate.bodyPl.$model"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <template v-if="validate.headerSk.$error">
                <div
                  v-for="(error, index) in validate.headerSk.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.headerEn.$error">
                <div
                  v-for="(error, index) in validate.headerEn.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.headerCs.$error">
                <div
                  v-for="(error, index) in validate.headerCs.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.headerDe.$error">
                <div
                  v-for="(error, index) in validate.headerDe.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.headerPl.$error">
                <div
                  v-for="(error, index) in validate.headerPl.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>

              <template v-if="validate.perexSk.$error">
                <div
                  v-for="(error, index) in validate.perexSk.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.perexEn.$error">
                <div
                  v-for="(error, index) in validate.perexEn.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.perexCs.$error">
                <div
                  v-for="(error, index) in validate.perexCs.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.perexDe.$error">
                <div
                  v-for="(error, index) in validate.perexDe.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.perexPl.$error">
                <div
                  v-for="(error, index) in validate.perexPl.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>

              <template v-if="validate.bodySk.$error">
                <div
                  v-for="(error, index) in validate.bodySk.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.bodyEn.$error">
                <div
                  v-for="(error, index) in validate.bodyEn.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.bodyCs.$error">
                <div
                  v-for="(error, index) in validate.bodyCs.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.bodyDe.$error">
                <div
                  v-for="(error, index) in validate.bodyDe.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.bodyPl.$error">
                <div
                  v-for="(error, index) in validate.bodyPl.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div
              class="mt-3"
              :class="{
                'border-theme-6': validate.image.$error
              }"
            >
              <label for="web" class="form-label w-full flex flex-col sm:flex-row">
                {{ $t('news.imageSquare') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }}
                </span>
              </label>
              <ImageUploader ref="imageUploader" :aspectRatio="1 / 1" />
              <template v-if="validate.image.$error">
                <div
                  v-for="(error, index) in validate.image.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div
              class="mt-3"
              :class="{
                'border-theme-6': validate.imageWide.$error
              }"
            >
              <label for="web" class="form-label w-full flex flex-col sm:flex-row">
                {{ $t('news.imageWide') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }}
                </span>
              </label>
              <WideImageUploader ref="imageWideUploader" />
              <template v-if="validate.imageWide.$error">
                <div
                  v-for="(error, index) in validate.imageWide.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label for="dateFrom" class="form-label w-full flex flex-col sm:flex-row">
                {{ $t('form.field.timeFrom') }}
              </label>
              <input
                id="dateFromView"
                v-model="dateFromView"
                class="form-check-switch"
                type="checkbox"
              />
              <div class="relative w-56" v-show="dateFromView">
                <div
                  class="absolute rounded-l w-10 h-full flex items-center justify-center bg-gray-100 border text-gray-600 dark:bg-dark-1 dark:border-dark-4"
                >
                  <CalendarIcon class="w-4 h-4" />
                </div>
                <Litepicker
                  v-model="dateFrom"
                  :options="{
                    autoApply: true,
                    singleMode: true,
                    numberOfColumns: 2,
                    numberOfMonths: 2,
                    minDate: dateConstraint,
                    dropdowns: {
                      minYear: 2023,
                      maxYear: null,
                      months: true,
                      years: true
                    },
                    lang: 'sk-SK'
                  }"
                  class="form-control pl-12 w-56 block mx-auto"
                />
              </div>
            </div>
            <div class="mt-3" v-show="dateFromView">
              <input
                id="timeFrom"
                v-model.trim="validate.timeFrom.$model"
                type="time"
                name="timeFrom"
                class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                :class="{
                  'border-theme-6': validate.timeFrom.$error
                }"
                placeholder="08:00"
              />
              <template v-if="validate.timeFrom.$error">
                <div
                  v-for="(error, index) in validate.timeFrom.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label for="dateTo" class="form-label w-full flex flex-col sm:flex-row">
                {{ $t('form.field.timeTo') }}
              </label>
              <input
                id="dateToView"
                v-model="dateToView"
                class="form-check-switch"
                type="checkbox"
              />
              <div class="relative w-56" v-show="dateToView">
                <div
                  class="absolute rounded-l w-10 h-full flex items-center justify-center bg-gray-100 border text-gray-600 dark:bg-dark-1 dark:border-dark-4"
                >
                  <CalendarIcon class="w-4 h-4" />
                </div>
                <Litepicker
                  v-model="dateTo"
                  :options="{
                    autoApply: true,
                    singleMode: true,
                    numberOfColumns: 2,
                    numberOfMonths: 2,
                    minDate: dateConstraint,
                    dropdowns: {
                      minYear: 2023,
                      maxYear: null,
                      months: true,
                      years: true
                    },
                    lang: 'sk-SK'
                  }"
                  class="form-control pl-12 w-56 block mx-auto"
                />
              </div>
            </div>
            <div class="mt-3" v-show="dateToView">
              <input
                id="timeTo"
                v-model.trim="validate.timeTo.$model"
                type="time"
                name="timeTo"
                class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                :class="{ 'border-theme-6': validate.timeTo.$error }"
                placeholder="08:00"
              />
              <template v-if="validate.timeTo.$error">
                <div
                  v-for="(error, index) in validate.timeTo.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="form-check flex-col items-start mt-3">
              <label for="active" class="form-check-label ml-0 mb-2">
                {{ $t('common.active') }}
              </label>
              <input
                id="active"
                v-model="validate.active.$model"
                name="active"
                class="form-check-switch"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('news.created') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('news.notCreated') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref, toRefs, reactive } from 'vue'
import { required, minLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'
import newsApi from '../../services/news/news.api'
import ImageUploader from '@/components/cdn/ImageUploader.vue'
import WideImageUploader from '@/components/cdn/WideImageUploader.vue'

export default defineComponent({
  components: {
    ImageUploader,
    WideImageUploader
  },
  methods: {
    handleSave(data) {
      this.loading = true

      this.formData.image = this.$refs.imageUploader.getValue()
      this.formData.imageWide = this.$refs.imageWideUploader.getValue()

      this.validate.$touch()
      if (this.validate.$invalid) {
        Toastify({
          node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.loading = false
        return
      }

      const saveRequest = {
        header: {
          sk_SK: data.target.elements.headerSk.value,
          en_US: data.target.elements.headerEn.value,
          cs_CZ: data.target.elements.headerCs.value,
          de_DE: data.target.elements.headerDe.value,
          pl_PL: data.target.elements.headerPl.value
        },
        perex: {
          sk_SK: data.target.elements.perexSk.value,
          en_US: data.target.elements.perexEn.value,
          cs_CZ: data.target.elements.perexCs.value,
          de_DE: data.target.elements.perexDe.value,
          pl_PL: data.target.elements.perexPl.value
        },
        body: {
          sk_SK: data.target.elements.bodySk.value,
          en_US: data.target.elements.bodyEn.value,
          cs_CZ: data.target.elements.bodyCs.value,
          de_DE: data.target.elements.bodyDe.value,
          pl_PL: data.target.elements.bodyPl.value
        },
        image: this.$refs.imageUploader.getValue(),
        imageWide: this.$refs.imageWideUploader.getValue(),
        visibleFrom: this.getDateTime(
          this.dateFromView,
          this.dateFrom,
          data.target.elements.timeFrom.value
        ),
        visibleTo: this.getDateTime(
          this.dateToView,
          this.dateTo,
          data.target.elements.timeTo.value
        ),
        active: data.target.elements.active.checked
      }

      newsApi.createNews(saveRequest).then(
        (response) => {
          Toastify({
            node: cash('#success-notification-content').clone().removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.$router.push({ name: 'superadmin-tools-news' })
        },
        (error) => {
          console.log(error)
          this.loading = false
          Toastify({
            node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }
      )
    },
    getDateTime(active, date, time) {
      if (active === false) {
        return null
      }
      this.console.log(
        date.replace(/^(\d+)\.(\d+)\.(\d+)$/, '$3-$2-$1') + 'T' + time + ':00'
      )
      const d = new Date(
        date.replace(/^(\d+)\.(\d+)\.(\d+)$/, '$3-$2-$1') + 'T' + time + ':00'
      )
      return d.toISOString()
    }
  },
  computed: {
    console: () => console
  },
  setup() {
    const loading = ref(false)
    const dateConstraint = new Date() - 1
    const dateFrom = ref('')
    const dateFromView = ref(false)
    const dateTo = ref('')
    const dateToView = ref(false)

    const formData = reactive({
      headerSk: '',
      headerEn: '',
      headerCs: '',
      headerDe: '',
      headerPl: '',
      perexSk: '',
      perexEn: '',
      perexCs: '',
      perexDe: '',
      perexPl: '',
      bodySk: '',
      bodyEn: '',
      bodyCs: '',
      bodyDe: '',
      bodyPl: '',
      image: '',
      imageWide: '',
      timeFrom: '',
      timeTo: '',
      active: true
    })

    const urlValidator = helpers.regex(/(https?:\/\/.*\.[a-z0-9]+)/i)
    const timeValidator = helpers.regex(/^([0-1][0-9]|2[0-4]):[0-5][0-9]$/)

    const rules = {
      headerSk: {
        required: helpers.withMessage('form.validation.name_sk.required', required),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      headerEn: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      headerCs: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      headerDe: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      headerPl: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      perexSk: {
        required: helpers.withMessage('form.validation.perex_sk.required', required),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      perexEn: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      perexCs: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      perexDe: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      perexPl: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      bodySk: {
        required: helpers.withMessage('form.validation.body_sk.required', required),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      bodyEn: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      bodyCs: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      bodyDe: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      bodyPl: {
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      image: {
        required: helpers.withMessage('form.validation.imageRequired', required),
        urlValidator: helpers.withMessage('form.validation.imageUrl', urlValidator)
      },
      imageWide: {
        required: helpers.withMessage('form.validation.imageRequired', required),
        urlValidator: helpers.withMessage('form.validation.imageUrl', urlValidator)
      },
      timeFrom: {
        timeValidator
      },
      timeTo: {
        timeValidator
      },
      active: {}
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      validate,
      formData,
      dateConstraint,
      dateFromView,
      dateFrom,
      dateToView,
      dateTo
    }
  }
})
</script>
